/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonSearchResultDto } from './PersonSearchResultDto';
import {
    PersonSearchResultDtoFromJSON,
    PersonSearchResultDtoFromJSONTyped,
    PersonSearchResultDtoToJSON,
    PersonSearchResultDtoToJSONTyped,
} from './PersonSearchResultDto';

/**
 * 
 * @export
 * @interface PersonSearchResponseDto
 */
export interface PersonSearchResponseDto {
    /**
     * 
     * @type {Array<PersonSearchResultDto>}
     * @memberof PersonSearchResponseDto
     */
    items?: Array<PersonSearchResultDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof PersonSearchResponseDto
     */
    hasMore?: boolean;
}

/**
 * Check if a given object implements the PersonSearchResponseDto interface.
 */
export function instanceOfPersonSearchResponseDto(value: object): value is PersonSearchResponseDto {
    return true;
}

export function PersonSearchResponseDtoFromJSON(json: any): PersonSearchResponseDto {
    return PersonSearchResponseDtoFromJSONTyped(json, false);
}

export function PersonSearchResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonSearchResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(PersonSearchResultDtoFromJSON)),
        'hasMore': json['hasMore'] == null ? undefined : json['hasMore'],
    };
}

export function PersonSearchResponseDtoToJSON(json: any): PersonSearchResponseDto {
    return PersonSearchResponseDtoToJSONTyped(json, false);
}

export function PersonSearchResponseDtoToJSONTyped(value?: PersonSearchResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(PersonSearchResultDtoToJSON)),
        'hasMore': value['hasMore'],
    };
}

